import React from 'react';
import { buildPasswordPolicyMessage } from 'app/components/SignUp/utils';
import { PasswordPolicy } from 'types/auth';
import { Text, TextProps } from '@chakra-ui/react';

interface PasswordPolicyMessageProps extends TextProps {
  passwordPolicy?: PasswordPolicy;
}

export const PasswordPolicyMessage: React.FC<PasswordPolicyMessageProps> = ({
  passwordPolicy,
  ...textProps
}) => {
  if (!passwordPolicy) return null;

  return (
    <Text
      mb="0.5px"
      fontSize="xs"
      lineHeight="small"
      textAlign="left"
      color="textSubdued"
      letterSpacing="0.15px"
      {...textProps}
      data-testid="password-policy"
    >
      {buildPasswordPolicyMessage(passwordPolicy)}
    </Text>
  );
};
